import { render, staticRenderFns } from "./AdditionalForm.vue?vue&type=template&id=0c43cfee&scoped=true&"
import script from "./AdditionalForm.vue?vue&type=script&lang=js&"
export * from "./AdditionalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43cfee",
  null
  
)

export default component.exports